/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { MyContext } from '../../Context/MyProvider';
import { showToast } from '../../showTost';
import Referlottie from "../Lottie/refernearn.json";
import Lottie from 'lottie-react';
import { MdOutlineContentCopy } from 'react-icons/md';
import Icon from "../../assets/Image/lovef.png";
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
const ReferAndEarn = () => {

    const { t } = useTranslation();
    const { ApiBaseUrl } = useContext(MyContext);

    const [data, setData] = useState([]);
    const [currency, setCurrency] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);

        const site_currency = secureLocalStorage.getItem("currency");
        const currency = site_currency ? site_currency : "$";
        setCurrency(currency);


        const Userid = secureLocalStorage.getItem("Userid");

        if (Userid) {

            axios.post(`${ApiBaseUrl}/customer/referral_data`, { id: Userid })
                .then((res) => {
                    // console.log(res);
                    setData(res.data.fererral_data);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error("referdata.php", error);
                });
        }
    }, []);

    const handleCopyClick = (textToCopy) => {
        navigator.clipboard.writeText(textToCopy).then(() => {
            showToast({ title: t("Text copied to clipboard !!"), id: "success" });
        }).catch((err) => {
            console.error('Failed to copy text: ', err);
        });
    };

    useEffect(() => {
        if (loading) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [loading]);

    return (
        <div className="w-full width-container content-wrapper">
            {loading
                ? <Loading CustomeStyle="h-[100vh] -mt-[140px] w-full flex items-center justify-center bg-white" index={0} />
                : <div className='h-[100vh] -mt-[150px] flex'>
                    <div className="w-[100%] flex items-center justify-center mt-[50px]">
                        <div className="profile-box">
                            <Lottie
                                className="w-[250px] mx-auto mb-[20px] max-_430_:w-[200px]"
                                animationData={Referlottie}
                                loop={true}
                            />
                            <h1 className='text-center  text-[20px]'>{t("Earn")} {currency ? currency : "$"}{data.signup_credit} {t("For Each Friend You Refer")}</h1>
                            <div className="flex items-center gap-[10px] mt-[15px]">
                                <img src={Icon} alt="Icon" className='w-[30px]' />
                                <h1 className='text-[18px]'>{t("Share the Referral Link with Your Friends")}</h1>
                            </div>
                            <div className="flex items-center gap-[10px] mt-[15px]">
                                <img src={Icon} alt="Icon" className='w-[30px]' />
                                <h1 className='text-[18px]'>{t("Friend Gets")} <span className=''>{currency ? currency : "$"}{data.signup_credit}</span> {t("On First Complete Transaction")} </h1>
                            </div>
                            <div className="flex items-center gap-[10px] mt-[15px]">
                                <img src={Icon} alt="Icon" className='w-[30px]' />
                                <h1 className='text-[18px]'>{t("You Get")} <span className=''>{currency ? currency : "$"}{data.refer_credit}</span> {t("On Your Wallet")}</h1>
                            </div>
                            <button onClick={() => handleCopyClick(data.referral_code)} className="w-[60%] max-_430_:w-[100%] mx-auto bg-[#3f38ff38] py-[8px] rounded-[10px] flex items-center justify-center gap-[40px] mt-[20px]">
                                <div className=' text-[18px]'>{data.referral_code}</div>
                                <MdOutlineContentCopy className='text-[blue]' />
                            </button>
                        </div>
                    </div>
                </div>}
        </div>
    )
}

export default ReferAndEarn
/* jshint ignore:end */